import { LanguageEnum } from 'gleblu-socket-api';
import React from 'react';

import supportedLocalizations from './localizations/supportedLocalizations';

const LocalizationContext = React.createContext(supportedLocalizations[LanguageEnum.ENGLISH]);

export default LocalizationContext;
